import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { CallDaoService } from 'features/call/call-base/services';
import type { PreviousCall } from 'features/call/vrs-call-comments/interfaces';
import { userIdSelector } from 'features/user/store';

// Type for the API response object
interface PreviousCallApiResponse {
  callId: number;
  startDt: string;
  endDt: string;
  lastState: string;
  callTypeStart: string;
  callTypeEnd: string;
  callerConnectionString: string;
  terminationReasonCode: string;
}

export const fetchPreviousCalls = createAsyncThunk(
  'vrsCallComments/fetchPreviousCalls',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const userId = userIdSelector(state);

      if (!userId) {
        return rejectWithValue('User ID not found');
      }

      const response =
        await CallDaoService.getLastFiveCallsByInterpreterId(userId);

      // Transform the API response to match our PreviousCall interface, filtering out calls without callId
      const transformedCalls: PreviousCall[] = Array.isArray(response)
        ? (response as PreviousCallApiResponse[])
            .filter((call) => call.callId)
            .map((call) => ({
              callId: call.callId,
              startTime: call.startDt,
              endTime: call.endDt,
              lastState: call.lastState,
              callTypeStart: call.callTypeStart,
              callTypeEnd: call.callTypeEnd,
              callerConnectionString: call.callerConnectionString,
              terminationReasonCode: call.terminationReasonCode,
            }))
        : [];

      return transformedCalls;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
